export default {
  'app.pwa.offline': 'Actualment fora de línia',
  'app.pwa.serviceworker.updated': 'Hi ha contingut nou',
  'app.pwa.serviceworker.updated.hint': 'Feu clic al botó "Actualitzar" o actualitzeu manualment la pàgina',
  'app.pwa.serviceworker.updated.ok': 'Actualitzar',
};
